import MuiModal, { ModalProps as MuiModalProps } from '@mui/material/Modal';
import { FC } from 'react';
import { FiPlus } from 'react-icons/fi';
import styled from 'styled-components';

import { breakpoints } from 'atoms/breakpoints/breakpoints';

import Container from 'quarks/Container';
import Flex from 'quarks/Flex';
import Grid from 'quarks/Grid';
import type { GridProps } from 'quarks/interpolations/grid';

const StyledModal = styled(MuiModal)`
  .MuiBackdrop-root {
    background-color: rgba(0, 0, 0, 0.9);
    display: grid;
    place-items: center;
  }
  form {
    .hs_submit {
      width: 100%;
    }
  }
  div[role=button] > svg {
    color: white;
  }

  @media screen and (max-width: ${breakpoints.md}) {
    .form-container {
      border-radius: 0px;
      min-height: 100dvh;
    }
    form {
      padding-bottom: 32px;
      .hs_submit {
          left: 0;
          position: fixed;
          background-color: white;
          bottom: 0;
          .actions {
            padding: 1rem 2.5rem 0.5rem 2.5rem;
          }
        }
      }
    }
  }
  @media (max-width: ${breakpoints.md}) {
      div[role=button] > svg {
        color: black;
      }
    }
  }
`;

interface ModalProps extends GridProps, MuiModalProps {
  /**
   * if true, the modal will be open
   */
  open: boolean;
  /**
   * Callback function for closing the modal.
   */
  onClose: () => void;
  /**
   * if true, close modal button is visible
   */
  hasCloseButton?: boolean;
  containerStyles?: string;
  keepMounted?: boolean;
}

const Modal: FC<ModalProps> = ({
  containerStyles,
  open,
  onClose,
  hasCloseButton = true,
  children,
  keepMounted = false,
  ...props
}) => (
  <StyledModal keepMounted={keepMounted} open={open} onClose={onClose}>
    <Grid
      position="absolute"
      css={`
        height: 100dvh;
        overflow-y: auto;
        position: relative;

        ${containerStyles}
      `}
    >
      <Flex
        position="relative"
        width="100%"
        display="flex"
        flexDirection="column"
        justifyContent="center"
        justifySelf="center"
      >
        <Container position="relative" {...props}>
          {hasCloseButton && (
            <Container
              role="button"
              cursor="pointer"
              position="absolute"
              transform="rotate(45deg)"
              top="0"
              right="0"
              zIndex="10"
              xs={{ top: '20px', right: '10px', position: 'absolute' }}
              md={{ right: '-30px', top: '30px', position: 'absolute' }}
              onClick={onClose}
            >
              <FiPlus size={30} strokeWidth={1} />
            </Container>
          )}

          {children}
        </Container>
      </Flex>
    </Grid>
  </StyledModal>
);

export default Modal;
